export default __webpack_public_path__ + "static/media/qr-code.452cc229.jpg";